/* eslint-disable react/style-prop-object */
/* eslint-disable max-lines */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';

const Svg = styled.svg`
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: auto;
  }
`;

const CoursePlaceholder = ({ color, className, width, height }) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 272 153"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_925_4585)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H264C268.418 0 272 3.58172 272 8V153H0V8Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.15"
      />
      <path
        d="M203.44 131.883C202.867 132.937 202.322 134.01 201.805 135.104L226.923 107.48C225.884 108.101 224.861 108.75 223.858 109.429L203.44 131.883Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M233.736 103.943L198.957 142.191C198.717 142.91 198.489 143.635 198.272 144.367L235.842 103.049C235.135 103.335 234.433 103.633 233.736 103.943Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M241.151 101.17L196.91 149.824C196.788 150.423 196.675 151.021 196.57 151.62L242.906 100.662C242.318 100.823 241.733 100.993 241.151 101.17Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M247.485 99.5843L195.928 156.284C195.876 156.809 195.829 157.333 195.79 157.858L249.038 99.2985C248.519 99.3875 248.001 99.4827 247.485 99.5843Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M253.152 98.7309L195.612 162.01C195.607 162.484 195.607 162.958 195.613 163.431L254.565 98.5985C254.093 98.6374 253.622 98.6816 253.152 98.7309Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M258.345 98.3996L195.771 167.215C195.802 167.65 195.838 168.085 195.878 168.519L259.653 98.3831C259.216 98.3841 258.78 98.3896 258.345 98.3996Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M263.171 98.4719L196.298 172.015C196.358 172.42 196.422 172.824 196.489 173.226L264.394 98.5483C263.986 98.5189 263.578 98.4934 263.171 98.4719Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M267.699 98.8729L197.124 176.486C197.208 176.865 197.296 177.243 197.387 177.62L268.851 99.0269C268.467 98.972 268.083 98.9207 267.699 98.8729Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M271.974 99.5514L198.205 180.679C198.309 181.035 198.417 181.391 198.528 181.745L273.066 99.7722C272.702 99.6953 272.338 99.6217 271.974 99.5514Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M276.03 100.47L199.506 184.628C199.629 184.964 199.755 185.3 199.883 185.634L277.069 100.75C276.724 100.654 276.378 100.561 276.03 100.47Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M279.891 101.604L201.004 188.36C201.144 188.678 201.286 188.996 201.431 189.312L280.882 101.937C280.553 101.823 280.223 101.712 279.891 101.604Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M283.574 102.934L202.682 191.894C202.837 192.196 202.995 192.497 203.154 192.797L284.519 103.317C284.205 103.187 283.89 103.059 283.574 102.934Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M287.09 104.45L204.528 195.247C204.697 195.533 204.869 195.819 205.042 196.103L287.992 104.879C287.693 104.734 287.392 104.591 287.09 104.45Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M290.445 106.138L206.529 198.424C206.712 198.697 206.896 198.967 207.083 199.237L291.307 106.612C291.021 106.452 290.734 106.294 290.445 106.138Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M293.65 107.993L208.68 201.439C208.875 201.697 209.073 201.954 209.272 202.209L294.473 108.511C294.2 108.336 293.926 108.164 293.65 107.993Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M296.709 110.009L210.974 204.295C211.182 204.54 211.393 204.783 211.604 205.024L297.494 110.568C297.234 110.379 296.973 110.193 296.709 110.009Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M299.627 112.18L213.41 206.997C213.63 207.229 213.852 207.458 214.076 207.686L300.375 112.78C300.127 112.578 299.878 112.378 299.627 112.18Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M302.405 114.504L215.982 209.546C216.215 209.764 216.449 209.981 216.685 210.195L303.116 115.143C302.881 114.928 302.643 114.715 302.405 114.504Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M305.046 116.98L218.694 211.946C218.939 212.15 219.185 212.353 219.433 212.554L305.721 117.66C305.498 117.432 305.273 117.205 305.046 116.98Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M307.549 119.608L221.543 214.192C221.801 214.383 222.059 214.573 222.32 214.76L308.187 120.328C307.976 120.086 307.764 119.846 307.549 119.608Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M309.914 122.39L224.534 216.285C224.804 216.463 225.075 216.638 225.348 216.812L310.515 123.151C310.316 122.895 310.116 122.642 309.914 122.39Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M312.135 125.326L227.667 218.219C227.949 218.382 228.234 218.544 228.519 218.703L312.697 126.129C312.512 125.86 312.324 125.592 312.135 125.326Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M314.211 128.425L230.95 219.99C231.246 220.139 231.543 220.286 231.842 220.43L314.734 129.271C314.562 128.988 314.387 128.706 314.211 128.425Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M316.132 131.689L234.384 221.591C234.694 221.724 235.006 221.855 235.319 221.984L316.614 132.581C316.455 132.283 316.295 131.985 316.132 131.689Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M317.893 135.132L237.984 223.013C238.309 223.13 238.635 223.245 238.963 223.357L318.33 136.074C318.187 135.759 318.041 135.445 317.893 135.132Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M319.482 138.767L241.757 224.244C242.099 224.344 242.441 224.442 242.785 224.536L319.871 139.761C319.744 139.429 319.615 139.097 319.482 138.767Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M320.882 142.607L245.716 225.271C246.076 225.352 246.436 225.43 246.796 225.505L321.218 143.66C321.109 143.308 320.997 142.957 320.882 142.607Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M322.074 146.677L249.881 226.071C250.261 226.131 250.64 226.187 251.02 226.24L322.35 147.795C322.261 147.421 322.169 147.049 322.074 146.677Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M323.028 151.005L254.279 226.612C254.681 226.648 255.083 226.679 255.485 226.707L323.237 152.198C323.171 151.8 323.101 151.402 323.028 151.005Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M323.708 155.637L258.952 226.853C259.382 226.859 259.811 226.861 260.239 226.859L323.836 156.919C323.798 156.491 323.755 156.063 323.708 155.637Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M324.058 160.633L263.956 226.73C264.419 226.7 264.882 226.666 265.343 226.626L324.085 162.025C324.081 161.56 324.072 161.096 324.058 160.633Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M323.991 166.089L269.377 226.15C269.884 226.074 270.39 225.991 270.895 225.903L323.887 167.625C323.928 167.112 323.962 166.6 323.991 166.089Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M323.365 172.155L275.352 224.957C275.922 224.815 276.489 224.665 277.054 224.508L323.078 173.893C323.182 173.313 323.278 172.734 323.365 172.155Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M321.913 179.132L282.16 222.85C282.833 222.6 283.502 222.339 284.166 222.067L321.328 181.198C321.533 180.515 321.729 179.826 321.913 179.132Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <path
        d="M318.955 187.766L290.501 219.058C291.417 218.56 292.32 218.04 293.211 217.498L317.672 190.598C318.12 189.668 318.548 188.724 318.955 187.766Z"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.1"
      />
      <mask
        id="mask0_925_4585"
        style={{ 'mask-type': 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-8"
        y="61"
        width="121"
        height="121"
      >
        <ellipse
          opacity="0.1"
          cx="5.36167"
          cy="146.674"
          rx="0.593114"
          ry="0.592751"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="17.813"
          cy="146.674"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.3"
          cx="30.2577"
          cy="146.673"
          r="1.77824"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="42.7099"
          cy="146.673"
          rx="1.77825"
          ry="1.77824"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.3"
          cx="55.1572"
          cy="146.673"
          r="1.77824"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.3"
          cx="66.414"
          cy="146.673"
          r="1.77824"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.3"
          cx="77.6796"
          cy="146.673"
          r="1.77824"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="88.94"
          cy="146.674"
          r="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="100.206"
          cy="146.674"
          rx="0.593113"
          ry="0.592751"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="111.762"
          cy="146.968"
          rx="0.296974"
          ry="0.296776"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="5.36167"
          cy="135.41"
          rx="0.593114"
          ry="0.592743"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="17.813"
          cy="135.409"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="30.2577"
          cy="135.412"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.5"
          cx="42.7089"
          cy="135.411"
          r="2.37099"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.5"
          cx="55.1552"
          cy="135.411"
          r="2.37099"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.5"
          cx="66.413"
          cy="135.411"
          rx="2.371"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="77.6796"
          cy="135.412"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="88.94"
          cy="135.409"
          r="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="100.206"
          cy="135.41"
          rx="0.593113"
          ry="0.592743"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="111.762"
          cy="135.707"
          rx="0.296974"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="5.36167"
          cy="124.148"
          rx="0.593114"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="17.813"
          cy="124.148"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="30.2577"
          cy="124.147"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.5"
          cx="42.7089"
          cy="124.146"
          rx="2.37099"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.6"
          cx="55.1542"
          cy="124.149"
          rx="2.96374"
          ry="2.96373"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.5"
          cx="66.413"
          cy="124.146"
          rx="2.371"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="77.6796"
          cy="124.147"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.2"
          cx="88.94"
          cy="124.148"
          rx="1.18606"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="100.206"
          cy="124.148"
          rx="0.593113"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="111.762"
          cy="124.446"
          rx="0.296974"
          ry="0.296783"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="5.36167"
          cy="111.7"
          rx="0.593114"
          ry="0.592743"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="17.813"
          cy="111.701"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="30.2577"
          cy="111.7"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.5"
          cx="42.7089"
          cy="111.699"
          rx="2.37099"
          ry="2.371"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.5"
          cx="55.1552"
          cy="111.699"
          rx="2.37099"
          ry="2.371"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.5"
          cx="66.413"
          cy="111.699"
          rx="2.371"
          ry="2.371"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="77.6796"
          cy="111.7"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="88.94"
          cy="111.701"
          r="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="100.206"
          cy="111.7"
          rx="0.593113"
          ry="0.592743"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="111.762"
          cy="111.998"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="5.36167"
          cy="99.2526"
          rx="0.593114"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="17.813"
          cy="99.2526"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="30.2577"
          cy="99.2513"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="42.7099"
          cy="99.2513"
          rx="1.77825"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="55.1572"
          cy="99.2513"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="66.414"
          cy="99.2513"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="77.6796"
          cy="99.2513"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="88.94"
          cy="99.2526"
          r="1.18606"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="100.206"
          cy="99.2526"
          rx="0.593113"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="111.762"
          cy="99.5499"
          rx="0.296974"
          ry="0.296787"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="5.36167"
          cy="86.8047"
          rx="0.593114"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.3"
          cx="17.813"
          cy="86.8052"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="30.2593"
          cy="86.8052"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="42.7046"
          cy="86.8052"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="55.1587"
          cy="86.8052"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="66.4165"
          cy="86.8052"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <circle
          opacity="0.2"
          cx="77.6821"
          cy="86.8052"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.2"
          cx="88.94"
          cy="86.8052"
          rx="1.18606"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="100.206"
          cy="86.8047"
          rx="0.593113"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="111.762"
          cy="87.1021"
          rx="0.296974"
          ry="0.296787"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          cx="5.36167"
          cy="74.3568"
          rx="0.593114"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="17.8148"
          cy="74.3568"
          rx="0.593114"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="30.2591"
          cy="74.3568"
          rx="0.593114"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="42.7054"
          cy="74.3568"
          rx="0.593115"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="55.1517"
          cy="74.3568"
          rx="0.593115"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="66.4164"
          cy="74.3568"
          rx="0.593117"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="77.6761"
          cy="74.3568"
          rx="0.593113"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="88.9408"
          cy="74.3568"
          rx="0.593113"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          cx="100.206"
          cy="74.3568"
          rx="0.593113"
          ry="0.592754"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          cx="111.762"
          cy="74.6542"
          rx="0.296974"
          ry="0.296787"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          cx="5.65928"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="18.1114"
          cy="62.2064"
          rx="0.296975"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="30.5567"
          cy="62.2064"
          rx="0.296975"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="43.003"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="55.4493"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="66.714"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="77.9737"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          opacity="0.1"
          cx="89.2374"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          cx="100.502"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
        <ellipse
          cx="111.762"
          cy="62.2064"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
        />
      </mask>
      <g mask="url(#mask0_925_4585)">
        <ellipse
          cx="52.7321"
          cy="119.997"
          rx="53.1442"
          ry="53.1442"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
      </g>
      <mask
        id="mask1_925_4585"
        style={{ 'mask-type': 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="143"
        y="-23"
        width="120"
        height="120"
      >
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="156.181"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="168.633"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="181.078"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="193.525"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="205.971"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="217.235"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="228.495"
          cy="96.0396"
          rx="0.296967"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="239.759"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          cx="251.024"
          cy="96.0396"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          cx="262.284"
          cy="96.0396"
          rx="0.296967"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="84.7784"
          rx="0.296974"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="84.481"
          rx="0.593109"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="168.336"
          cy="84.481"
          rx="0.593109"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="180.781"
          cy="84.481"
          rx="0.593109"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="193.227"
          cy="84.481"
          rx="0.593117"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="205.673"
          cy="84.481"
          rx="0.593109"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="216.938"
          cy="84.481"
          rx="0.593117"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="228.198"
          cy="84.481"
          rx="0.593124"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="239.462"
          cy="84.481"
          rx="0.593109"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          cx="250.728"
          cy="84.481"
          rx="0.593117"
          ry="0.592747"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          cx="262.284"
          cy="84.7784"
          rx="0.296967"
          ry="0.296795"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="73.5167"
          rx="0.296974"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="73.2199"
          rx="0.593109"
          ry="0.592751"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.3"
          cx="168.334"
          cy="73.2198"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="180.781"
          cy="73.2198"
          rx="1.18606"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.2"
          cx="193.226"
          cy="73.2198"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="205.679"
          cy="73.2198"
          rx="1.18607"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="216.938"
          cy="73.2198"
          rx="1.18606"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="228.204"
          cy="73.2198"
          rx="1.18604"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.2"
          cx="239.461"
          cy="73.2198"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="73.2199"
          rx="0.593117"
          ry="0.592751"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="73.5167"
          rx="0.296967"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="62.2521"
          rx="0.296974"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="61.9581"
          rx="0.593109"
          ry="0.592745"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.3"
          cx="168.334"
          cy="61.9586"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="180.779"
          cy="61.9569"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="193.231"
          cy="61.9569"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="205.679"
          cy="61.9569"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="216.935"
          cy="61.9569"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="228.201"
          cy="61.9569"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.2"
          cx="239.461"
          cy="61.9586"
          r="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="61.9581"
          rx="0.593117"
          ry="0.592745"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="62.2521"
          rx="0.296967"
          ry="0.296793"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="50.991"
          rx="0.296974"
          ry="0.296783"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="50.6936"
          rx="0.593109"
          ry="0.592743"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="168.334"
          cy="50.6935"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="180.779"
          cy="50.6957"
          rx="1.77824"
          ry="1.77824"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.5"
          cx="193.23"
          cy="50.6951"
          r="2.37099"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="205.677"
          cy="50.6951"
          rx="2.37099"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="216.934"
          cy="50.6951"
          rx="2.37099"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.3"
          cx="228.201"
          cy="50.6957"
          r="1.77824"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="239.461"
          cy="50.6935"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="50.6936"
          rx="0.593117"
          ry="0.592743"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="50.991"
          rx="0.296967"
          ry="0.296783"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="39.7298"
          rx="0.296974"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="39.4323"
          rx="0.593109"
          ry="0.592745"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="168.334"
          cy="39.4324"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="180.779"
          cy="39.4312"
          rx="1.77824"
          ry="1.77824"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="193.23"
          cy="39.4306"
          rx="2.37099"
          ry="2.371"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.6"
          cx="205.676"
          cy="39.4334"
          rx="2.96374"
          ry="2.96374"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="216.934"
          cy="39.4306"
          rx="2.37099"
          ry="2.371"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <circle
          opacity="0.3"
          cx="228.201"
          cy="39.4312"
          r="1.77824"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="239.461"
          cy="39.4324"
          rx="1.18605"
          ry="1.18606"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="39.4323"
          rx="0.593117"
          ry="0.592745"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="39.7298"
          rx="0.296967"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="27.2819"
          rx="0.296974"
          ry="0.296792"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="26.9845"
          rx="0.593109"
          ry="0.592749"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="168.334"
          cy="26.9851"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="180.779"
          cy="26.9833"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="193.23"
          cy="26.9827"
          rx="2.37099"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="205.677"
          cy="26.9827"
          rx="2.37099"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.5"
          cx="216.934"
          cy="26.9827"
          rx="2.37099"
          ry="2.37099"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="228.201"
          cy="26.9833"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="239.461"
          cy="26.9851"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="26.9845"
          rx="0.593117"
          ry="0.592749"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="27.2819"
          rx="0.296967"
          ry="0.296792"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="14.8341"
          rx="0.296974"
          ry="0.29679"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="14.5367"
          rx="0.593109"
          ry="0.592749"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="168.334"
          cy="14.5366"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="180.779"
          cy="14.5355"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="193.231"
          cy="14.5355"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="205.679"
          cy="14.5355"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="216.935"
          cy="14.5355"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="228.201"
          cy="14.5355"
          rx="1.77824"
          ry="1.77825"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="239.461"
          cy="14.5366"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="14.5367"
          rx="0.593117"
          ry="0.592749"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="14.8341"
          rx="0.296967"
          ry="0.29679"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="143.734"
          cy="2.38619"
          rx="0.296974"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="155.883"
          cy="2.08879"
          rx="0.593109"
          ry="0.592749"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.3"
          cx="168.334"
          cy="2.08931"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="180.781"
          cy="2.08931"
          rx="1.18606"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="193.226"
          cy="2.08931"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="205.679"
          cy="2.08931"
          rx="1.18607"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="216.938"
          cy="2.08931"
          rx="1.18606"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="228.204"
          cy="2.08931"
          rx="1.18604"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.2"
          cx="239.461"
          cy="2.08931"
          rx="1.18605"
          ry="1.18605"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="250.728"
          cy="2.08879"
          rx="0.593117"
          ry="0.592749"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
        <ellipse
          opacity="0.1"
          cx="262.284"
          cy="2.38619"
          rx="0.296967"
          ry="0.296791"
          fill={color || 'var(--color-i-text-black)'}
          fillOpacity="0.3"
        />
      </mask>
      <g mask="url(#mask1_925_4585)">
        <circle
          cx="203.253"
          cy="35.282"
          r="53.1442"
          fill={color || 'var(--color-i-text-black)'}
        />
      </g>
      <circle
        cx="136"
        cy="77"
        r="68"
        fill={color || 'var(--color-i-text-black)'}
        fillOpacity="0.15"
      />
    </g>
    <defs>
      <clipPath id="clip0_925_4585">
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H264C268.418 0 272 3.58172 272 8V153H0V8Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </Svg>
);

export default CoursePlaceholder;

CoursePlaceholder.propTypes = {
  color: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
};

CoursePlaceholder.defaultProps = {
  width: '272px',
  height: '153px',
  className: ''
};
